import { fromJS } from 'immutable';
import Constants from '../../constants';

const { Vendor } = Constants;

const initialState = fromJS({
  vendor: {},
  loading: false,
});

/**
 * Returns and sets the next state based on the action passed to it
 * @param {object} state state object that defaults to the initial state
 * @param {object} action action object containing action type and payload properties
 */
const vendorTeamMemberReducer = (state = initialState, action) => {
  const { vendor } = action;

  switch (action.type) {
    case Vendor.GET_VENDOR_SUCCESS:
    case Vendor.SET_VENDOR:
      return state.set('vendor', fromJS(vendor));
    default:
      return state;
  }
};

export default vendorTeamMemberReducer;
